import axios from "axios";
import CryptoJS from "crypto-js";
import XXTEA from "./xxtea";
import _ from "lodash";
import cookie from "../util/cookie";
import { Loading } from "element-ui";
import { SIGN_KEY, ENCRYPT_KEY } from "../../public/config/env";

// 请求加密
axios.interceptors.request.use(
  (config) => {
    let isAPIRequest = config.url.indexOf(env.API_HOST) == 0 ? true : false;
    if (isAPIRequest) {
      var params = config.data || {};
      if (params != undefined) {
        for (let key in params) {
          // if (params[key] === null || params[key] === undefined) {
          //   delete params[key];
          // }
          if (params[key] === undefined) {
            delete params[key];
          }
        }
        // // 对指定关键字加密
        // for (let key in params) {
        //     params[key] = keysEncryption(key, params)
        // }
        // config.headers['X-DAYI-Sign'] = getSign(params);
        config.data = params; // 如果需要对请求参数加密:getEncryption(params)

        // config.headers['X-DAYI-Sign'] = null
        // console.log("token", cookie.getCookie("token"));
        if (params.adminToken) {
          config.headers["x-auth-token"] = params.adminToken;
          delete config.data.adminToken;
        } else {
          config.headers["x-auth-token"] = cookie.getCookie("token");
        }
      }
    }
    //以form-data格式请求，params带headers对象
    if (config.data && config.data.headers) {
      for (let key in config.data.headers) {
        config.headers[key] = config.data.headers[key];
        delete config.data.headers;
      }
      if (config.headers["Content-Type"] == "multipart/form-data") {
        let formData = new FormData();
        for (let i in config.data) {
          formData.append(i, config.data[i]);
        }
        config.data = formData;
      }
    }
    return config;
  },
  (error) => {
    console.log("网络请求错误");
    return Promise.reject(error);
  }
);

// 响应解密
axios.interceptors.response.use(
  (response) => {
    if (response) {
      // let isAPIRequest = response.config.url.indexOf(env.API_HOST) == 0 ? true : false;
      // if (isAPIRequest) {
      // if (response.data) {
      // 如果是POST请求或者PUT就关闭loding
      // if (response.config.method == "post" || response.config.method == "put") {
      //   hideLoading();
      // }
      // console.log('响应',response)
      if (response.data.code == "10001006" || response.data.code == "10002") {
        // console.log(response.data);
        // return
        cookie.clearCookie("token");
        cookie.clearCookie("user");
        console.log("身份过期");
        window.location.pathname = "/login";
        setTimeout(function() {
          window.location.search = "?errorMsg=" + response.data.msg;
        }, 1000);
      }
      return response.data;
      // }
      // } else {
      //     console.log("请求地址错误!");
      // }
    } else {
      console.log("网络错误");
      // if (response.config.method == "post" || response.config.method == "put") {
      //   hideLoading();
      // }
    }
  },
  (error) => {
    // if (
    //   error.response.config.method == "post" ||
    //   error.response.config.method == "put"
    // ) {
    //   hideLoading();
    // }
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.code) {
          return error.response.data;
        } else {
          return Promise.reject(error.response.data);
        }
      } else {
        return Promise.reject(error.response.data);
      }
    } else {
      var data = {
        message: error.message,
        success: false,
      };
      return Promise.reject(data);
    }
  }
);

// 发起请求
export function fetchEndpoint(reqUrl, type = "POST", data = {}) {
  if (!reqUrl) {
    return;
  }
  type = type.toUpperCase();
  reqUrl = env.API_HOST + reqUrl;
  if (type == "GET") {
    let dataStr = ""; //数据拼接字符串
    Object.keys(data).forEach((key) => {
      dataStr +=
        key + "=" + (data[key] ? encodeURI(data[key]) : data[key]) + "&";
    });
    if (dataStr !== "") {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      reqUrl = reqUrl + "?" + dataStr;
    }
  }

  // 如果是POST请求或者PUT就显示loding
  // if (type == "POST" || type == "PUT") {
  //   if (!data.noShowLoading) {
  //     showLoading();
  //     delete data.noShowLoading;
  //   }
  // }

  return new Promise((resolve, reject) => {
    axios({
      method: type,
      url: reqUrl,
      data: data,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 数据加密
function getEncryption(params) {
  let post_body = toQueryString(params);
  let encry_post_body = "";
  let body = null;
  if (post_body && post_body.length) {
    encry_post_body = XXTEA.encryptToBase64(post_body, ENCRYPT_KEY);
    body = toQueryString({ x: encry_post_body });
    body = body.replace(/\+/g, "%2B");
  }
  return body;
}

// 生成签名
function getSign(params) {
  var resultStr = toQueryString(params);
  var timestamp = Date.parse(new Date()) / 1000 + "";
  var formData = timestamp + resultStr;
  var signData = CryptoJS.HmacSHA256(formData, SIGN_KEY).toString();
  return signData + "," + timestamp;
}

// 加密指定字段
function keysEncryption(key, params) {
  // 需要加密的字段名
  let encryption_keys = [
    "username",
    "password",
    "old_password",
    "mobile",
    "old_password",
  ];
  let key_value = params[key];
  for (var i = 0; i < encryption_keys.length; i++) {
    // 是否需要为需要加密的字段
    if (key === encryption_keys[i]) {
      return btoa(key_value);
    }
  }
  return key_value;
}

function toQueryString(obj) {
  return obj
    ? Object.keys(obj)
        .sort()
        .map(function(key) {
          var val = obj[key];
          if (Array.isArray(val)) {
            return val
              .sort()
              .map(function(val2) {
                return key + "=" + filterSpecialChars(encodeURIComponent(val2));
              })
              .join("&");
          }
          return key + "=" + filterSpecialChars(encodeURIComponent(val));
        })
        .join("&")
    : "";
}

function filterSpecialChars(str) {
  if (str && str.length) {
    // 处理特殊字符: ! ~ * ' ( )
    str = str.replace(/\!/g, "%21");
    str = str.replace(/\~/g, "%7e");
    str = str.replace(/\*/g, "%2A");
    str = str.replace(/\'/g, "%27");
    str = str.replace(/\(/g, "%28");
    str = str.replace(/\)/g, "%29");
  }
  return str;
}

//loading对象
let loading = "";

//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading() {
  // 后面这个判断是因为关闭时加了抖动，此时loading对象可能还存在
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: "加载中...",
      background: "rgba(255, 255, 255, 0.5)",
      target: "body",
      customClass: "app-post-loding",
    });
  }
  needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
  needLoadingRequestCount--;
  needLoadingRequestCount = Math.max(needLoadingRequestCount, 0);
  if (needLoadingRequestCount === 0) {
    //防抖：将300ms间隔内的关闭loading便合并为一次。防止连续请求时，生成多个loading，造成闪烁的问题。
    toHideLoading();
  }
}
// //防抖：将300ms间隔内的关闭loading便合并为一次。防止连续请求时，生成多个loading，造成闪烁的问题。
var toHideLoading = _.debounce(() => {
  if (loading) {
    loading.close();
    loading = null;
  }
}, 300);
